import Text from './Text'
import TextSkeleton from './TextSkeleton'

export default Text
export { TextSkeleton }
